<template>
    <div class="main-container">
        <div class="alert alert__connexion tag__connection" v-if="loadingConnection">
          <div class="alert__header">
              <div class="alert__title">
                  <p>{{translationArray.connecting}}</p>
                  <div class="loading">
                      <div class="animateSpin">
                          <div class="loader">
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <header class="headerBlue">
                <svg class="waves" width="455" height="455" viewBox="0 0 455 455" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="227.949" cy="227.949" r="124.244" stroke="#3CB5A8"/>
                    <circle cx="227.949" cy="227.948" r="173.603" stroke="#3CB5A8" stroke-opacity="0.4"/>
                    <circle cx="227.5" cy="227.5" r="227" stroke="#3CB5A8" stroke-opacity="0.1"/>
                </svg>
                <a @click="historyBack()" class="btnBack">
                    <span class="btnBack__svg">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="arrow_back_24px">
                        <path id="icon/navigation/arrow_back_24px" d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="#3CB5A8"/>
                        </g>
                        </svg>
                    </span>
                </a>
            <div class="containerTitle">
                <h1>{{translationArray.connection}}</h1>
                <p><span>{{translationArray.on}}</span><span>{{this.$senzuAuth.nameClient}}</span></p>
            </div>

            <div class="containerPartner">
                <div class="partnerBox partnerBox__Left" v-if="!isSenzuApp">
                    <img v-if="!this.$senzuAuth.hasImageClient" src="../../static/img/logo.png" :alt="'image_' + this.$senzuAuth.nameClient">
                    <img v-if="this.$senzuAuth.hasImageClient" :src="this.$senzuAuth.urlImageClient" :alt="'image' + this.$senzuAuth.nameClient">
                </div>
                <div class="partnerSeparation" v-if="!isSenzuApp">
                    <svg width="34" height="54" viewBox="0 0 34 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M33.0607 13.0607C33.6464 12.4749 33.6464 11.5251 33.0607 10.9393L23.5147 1.3934C22.9289 0.807611 21.9792 0.807611 21.3934 1.3934C20.8076 1.97919 20.8076 2.92893 21.3934 3.51472L29.8787 12L21.3934 20.4853C20.8076 21.0711 20.8076 22.0208 21.3934 22.6066C21.9792 23.1924 22.9289 23.1924 23.5147 22.6066L33.0607 13.0607ZM1 13.5H32V10.5H1V13.5Z" fill="#EEEEEE"/>
                        <path d="M0.939339 40.9393C0.353554 41.5251 0.353554 42.4749 0.939339 43.0607L10.4853 52.6066C11.0711 53.1924 12.0208 53.1924 12.6066 52.6066C13.1924 52.0208 13.1924 51.0711 12.6066 50.4853L4.12132 42L12.6066 33.5147C13.1924 32.9289 13.1924 31.9792 12.6066 31.3934C12.0208 30.8076 11.0711 30.8076 10.4853 31.3934L0.939339 40.9393ZM33 40.5H2V43.5H33V40.5Z" fill="#EEEEEE"/>
                    </svg>
                </div>
                <div class=" partnerBox partnerBox__Right">
                    <img src="../../static/img/senzu.png" alt="">
                </div>
            </div>
            <div class="containerDescription">
                <p class="information__title__computer">{{translationArray.choose_account}}</p>

                <p class="containerDescription__p">{{translationArray.choose_account}}</p>
            </div>
        </header>
        <section class="bodyBlue">
            <div class="userBox" v-bind:class="'userBox-' + index" :data-order="user.id" v-for="(user, index) in users" :key="user.id" :index="index" @click="chooseUser(user.id)">
                <div class="contentImgUser">
                    <div class="imgUser">
                        <img :src="user.urlImage" alt="">
                    </div>
                </div>
                <div class="contentInfoUser">
                    <p><span class="contentInfoUser__name">{{user.firstname}} {{user.lastname}}</span></p>
                    <p><span class="contentInfoUser__description"></span></p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import {translate} from '../../static/js/translate';

export default {
  name: 'ChooseUsers',
  mounted() {
      this.translationArray = translate(navigator.language.substr(0, 2));

      let clientId = typeof(this.$route.query.client_id) !== "undefined" ? this.$route.query.client_id : null;
      if(clientId <= 8 || typeof(clientId) == 'undefined') {
          this.isSenzuApp = true;
      }

      window.addEventListener("resize", this.handleResize);
      this.handleResize();

      this.$senzuAuth.nameClient = localStorage.getItem("name_client");
      this.$senzuAuth.urlImageClient = localStorage.getItem("url_image_client");
      this.$senzuAuth.hasImageClient = localStorage.getItem("has_image_client");

      let idRecord = this.$route.query.id_record;
      let keyRecord = this.$route.query.key;
      fetch(`${this.$origin}/nfc/users?id_record=${idRecord}&key=${keyRecord}&client_id=${clientId}`, {
          method: "GET",
          headers: {
              'Content-Type': 'application/json',
              'CSRF-Token': this.csrfToken
          },
      }).then(result => result.json())
        .then(data => {
            if(data.error == 200) {
                this.users = data.result;
                if(data.ntag424) {
                    localStorage.setItem("ntag424", true);
                } else {
                    localStorage.setItem("ntag424", false);
                }
            }          
        });
  },
  data () {
    return {
        users: null,
        isSenzuApp: false,
        idRecord: this.$route.query.id_record,
        keyRecord: this.$route.query.key,
        loadingConnection: false,
        isDesktop: false,
        isMobile: true,
        titleData: "Sélectionnez un compte",
        translationArray: {},
        csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  },
  methods: {
      handleResize: function() {
          if(window.innerWidth <= 1120) {
              this.isMobile = true;
              this.isDesktop = false;
          } else {
              this.isMobile = false;
              this.isDesktop = true;
          }
      },
      historyBack: function() {
        this.$router.replace({name: localStorage.getItem("last_page"), query:
            {
                client_id: this.$route.query.client_id, 
                redirect_uri: this.$route.query.redirect_uri,
                response_type: this.$route.query.response_type,
                scope: this.$route.query.scope,
                code_challenge: this.$route.query.code_challenge,
                code_challenge_method: this.$route.query.code_challenge_method,
                state: this.$route.query.state,
            }
        });
      },
      chooseUser: function(idUser) {
        localStorage.setItem("last_page", "ChooseUsers");
        
        fetch(`${this.$origin}/nfc/users?id_record=${this.idRecord}&key=${this.keyRecord}&client_id=${this.$route.query.client_id}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'CSRF-Token': this.csrfToken
            },
        }).then(result => result.json())
        .then(data => {
            if(data.error == 200) {
                this.users = data.result;
                let _this = this;
                this.users.forEach(function(element, index) {
                    if(element.id == idUser) {
                        if(element.is_pin_saved && data.ntag424) {
                            let params = "?client_id="+ _this.$route.query.client_id + "&response_type=" + _this.$route.query.response_type + "&redirect_uri=" + _this.$route.query.redirect_uri 
                            + "&scope=" + _this.$route.query.scope + "&code_challenge=" + _this.$route.query.code_challenge + "&code_challenge_method=" 
                            + _this.$route.query.code_challenge_method + "&state=" + _this.$route.query.state + "&id_record=" + _this.idRecord + "&key=" + _this.keyRecord + "&id_user=" + idUser;
                            
                            fetch(`${this.$origin}/check-login${params}`, {
                                method: "POST",
                                headers: {
                                    'Content-Type': 'application/json',
                                    'CSRF-Token': _this.csrfToken
                                },
                                body: JSON.stringify(data)
                            }).then(result => result.json())
                                .then(data => {
                                if(data.redirect_uri != null) {
                                    _this.loadingConnection = true;
                                    window.location.href = data.redirect_uri;
                                } else {
                                    $( '.userBox' ).each(function( index ) {
                                        if( $(this).data('order') !=  idUser ) {
                                        // if ( ie == false ) {
                                        var myVar = setInterval(test, 500);
                                        // }
                                        var unselectBox = $(this);
                                            $(this).addClass('userBox__hide');
                                            function test() {
                                                unselectBox.addClass('userBox__delete');
                                                var myVarr = setInterval(testt, 700);
                                                $('.bodyBlue').addClass('padding-top-none');

                                                function testt() {
                                                    unselectBox.css('display','none');

                                                    if (window.matchMedia("(min-width: 1120px)").matches) {
                                                        $('.userBox').addClass('userAnim');
                                                        $('.bodyBlue').addClass('bodyAnim');


                                                        var interval = setInterval(moveToLeft, 20);

                                                        function moveToLeft() {
                                                            if (window.matchMedia("(min-width: 1824px)").matches) {
                                                                $('.userBox').addClass('userAnim--after');
                                                            clearInterval(interval);
                                                            } else {
                                                            $('.userBox').addClass('userAnim--after');
                                                                clearInterval(interval);
                                                            }
                                                        }
                                                    }
                                                    clearInterval(myVarr);
                                                }
                                                clearInterval(myVar);
                                            }
                                        }
                                    });
                                    localStorage.setItem("url_image_user", element.urlImage);
                                    let intervalRedirect = setInterval(function() {
                                        _this.$router.replace({name: 'AskPin', query: {
                                            id_user: idUser, 
                                            id_record: _this.$route.query.id_record, 
                                            key: _this.$route.query.key,
                                            client_id: _this.$route.query.client_id, 
                                            redirect_uri: _this.$route.query.redirect_uri,
                                            response_type: _this.$route.query.response_type,
                                            scope: _this.$route.query.scope,
                                            code_challenge: _this.$route.query.code_challenge,
                                            code_challenge_method: _this.$route.query.code_challenge_method,
                                            state: _this.$route.query.state,
                                            }
                                        });
                                        clearInterval(intervalRedirect);
                                    }, 2000);
                                }
                            });
                        } else {
                            $( '.userBox' ).each(function( index ) {
                                if( $(this).data('order') !=  idUser ) {
                                // if ( ie == false ) {
                                var myVar = setInterval(test, 500);
                                // }
                                var unselectBox = $(this);
                                    $(this).addClass('userBox__hide');
                                    function test() {
                                        unselectBox.addClass('userBox__delete');
                                        var myVarr = setInterval(testt, 700);
                                        $('.bodyBlue').addClass('padding-top-none');

                                        function testt() {
                                            unselectBox.css('display','none');

                                            if (window.matchMedia("(min-width: 1120px)").matches) {
                                                $('.userBox').addClass('userAnim');
                                                $('.bodyBlue').addClass('bodyAnim');


                                                var interval = setInterval(moveToLeft, 20);

                                                function moveToLeft() {
                                                    if (window.matchMedia("(min-width: 1824px)").matches) {
                                                        $('.userBox').addClass('userAnim--after');
                                                    clearInterval(interval);
                                                    } else {
                                                    $('.userBox').addClass('userAnim--after');
                                                        clearInterval(interval);
                                                    }
                                                }

                                                var intervalTitle = setInterval(function() {
                                                    _this.titleData = _this.translationArray.enter_pin;      
                                                    clearInterval(intervalTitle);
                                                }, 700);
                                            }
                                            clearInterval(myVarr);
                                        }
                                        clearInterval(myVar);
                                    }
                                }
                            });
                            localStorage.setItem("url_image_user", element.urlImage);
                            localStorage.setItem("firstname_user", element.firstname);
                            localStorage.setItem("lastname_user", element.lastname);
                            let intervalRedirect = setInterval(function() {
                                _this.$router.replace({name: 'AskPin', query: {
                                    id_user: idUser, 
                                    id_record: _this.$route.query.id_record, 
                                    key: _this.$route.query.key,
                                    client_id: _this.$route.query.client_id, 
                                    redirect_uri: _this.$route.query.redirect_uri,
                                    response_type: _this.$route.query.response_type,
                                    scope: _this.$route.query.scope,
                                    code_challenge: _this.$route.query.code_challenge,
                                    code_challenge_method: _this.$route.query.code_challenge_method,
                                    state: _this.$route.query.state,
                                    }
                                });
                                clearInterval(intervalRedirect);
                            }, 2000);
                        }
                    }
                });  
            }
        });
      },
      animation: function() {
        
      }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ChooseUsers.vue